// ControlManager.ts
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ControlManager extends Vue {
    // コントロールの元の活性状態を保存するマップ
    private beforeDisableConditions: WeakMap<Vue, boolean> = new WeakMap();
    // コントロールごとの実行中の処理数を追跡するマップ
    private activeProcesses: WeakMap<Vue, number> = new WeakMap();

    /**
     * コントロールを一時非活性にする
     * @param control 制御対象のコントロール
     */
    public disableControl(control: Vue): void {

        const element = this.getElement(control);

        if (element) {
            // 最初の処理が開始されたときにコントロールの元の状態を保存し、無効化する

            //対象コントロールを非活性化する最初の処理の場合
            if (!this.activeProcesses.has(control)) {
                //元の活性状態を記録
                this.beforeDisableConditions.set(control, element.hasAttribute('disabled'));

                //非活性に設定する
                this.setDisabledRecursive(element, true, true);

                //実行中処理のカウントをセットアップ
                this.activeProcesses.set(control, 0);
            }
            // 実行中処理のカウントを増やす(カウントアップ)
            this.activeProcesses.set(control, this.activeProcesses.get(control)! + 1);
        }
    }

    /**
     * コントロールの一時非活性を解除し、元の状態に戻す
     * @param control 制御解除対象のコントロール
     */
    public restoreControl(control: Vue): void {
        const element = this.getElement(control);

        if (element && this.activeProcesses.has(control)) {
            // 実行中の処理のカウントを減らす
            const count = this.activeProcesses.get(control)! - 1;

            //対象コントロールのすべての処理が完了時
            if (count === 0) {

                //元の状態がTRUEのとき
                if (this.beforeDisableConditions.get(control)) {
                    this.setDisabledRecursive(element, true, false);
                } else {
                    this.setDisabledRecursive(element, false, false);
                }

                //マップを解放する
                this.beforeDisableConditions.delete(control);
                this.activeProcesses.delete(control);

            } else {
                //対象コントロールの実行中の処理が残っている場合

                //処理残数を更新（カウントダウン）
                this.activeProcesses.set(control, count);
            }
        }
    }

    private getElement(control: Vue): HTMLElement | null {
        let element: HTMLElement | null = control.$el as HTMLElement;

        // $elが利用できない場合、$refsを動的にチェックしてDOM要素を取得
        if (!element) {
            for (const key in control.$refs) {
                if (control.$refs[key] instanceof HTMLElement) {
                    element = control.$refs[key] as HTMLElement;
                    break;
                }
            }
        }

        return element;
    }

    private setDisabledRecursive(element: HTMLElement, disabled: boolean, setFlg:boolean): void {
        if (disabled) {
            element.setAttribute('disabled', 'true');

            if (setFlg) {
                element.style.pointerEvents = 'none';
                element.style.opacity = '0.8';
            } else {
                //解除時に非活性を解除する
                element.style.pointerEvents = '';
                element.style.opacity = '';
            }
        } else {
            element.style.pointerEvents = '';
            element.style.opacity = '';
            element.removeAttribute('disabled');
        }
        Array.from(element.children).forEach(child => {
            this.setDisabledRecursive(child as HTMLElement, disabled, setFlg);
        });
    }
}